import get from 'lodash/get';

export default (state: any) => get(state, `smartFaq`);
